import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-vip-crown-line text-2xl ${isScrolled || !isHome ? 'text-primary-500' : 'text-accent-500'}`}></i>
            </div>
            <span className={`text-lg font-bold font-heading ${isScrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}>
              皇冠体育
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? isScrolled || !isHome
                    ? 'bg-primary-50 text-primary-700 font-medium'
                    : 'bg-white/20 text-white font-medium'
                  : isScrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-50 text-primary-700 font-medium'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-full transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-50 text-primary-700 font-medium'
                  : isScrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="px-5 py-2 text-sm bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors font-medium whitespace-nowrap cursor-pointer">
              立即注册
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center cursor-pointer ${isScrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 space-y-1">
            <Link to="/" className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 rounded-lg">首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 rounded-lg">{cat.name}</Link>
            ))}
            <Link to="/about" className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 rounded-lg">关于我们</Link>
            <div className="pt-2">
              <button className="w-full px-5 py-2.5 text-sm bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors font-medium cursor-pointer">
                立即注册
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}